import { render, staticRenderFns } from "./MultiselectOption.vue?vue&type=template&id=57dbbc6c&scoped=true&"
import script from "./MultiselectOption.vue?vue&type=script&lang=js&"
export * from "./MultiselectOption.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectOption.vue?vue&type=style&index=0&id=57dbbc6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dbbc6c",
  null
  
)

export default component.exports